import React from 'react';
import DocumentManager from '../components/DocumentManager';
import CodeSelection from '../components/CodeSelection';
import UserPromptManager from '../components/UserPromptManager';
import DataManager from '../components/DataManager';
import TileDetailUnavailable from '../components/TileDetailUnavailable';
import {
    DocIcon,
    CodeIcon,
    BookmarkIcon,
    DataIcon,
    TestCaseIcon,
} from '../assets/SvgIcons';

const getTile = (tile, handleClose, setPromptCallBack) => {
    if (!tile) return null;

    switch (tile.tileType) {
        case 'DocumentUpload':
            return (
                <DocumentManager
                    show={true}
                    onClose={handleClose}
                    icon={<DocIcon />}
                    title={tile.title}
                />
            );
        case 'CodeEditor':
            return (
                <CodeSelection
                    show={true}
                    onClose={handleClose}
                    icon={<CodeIcon />}
                    title={tile.title}
                    setPromptCallBack={setPromptCallBack}
                />
            );
        case 'PromptManager':
            return (
                <UserPromptManager
                    show={true}
                    onClose={handleClose}
                    icon={<BookmarkIcon />}
                    title={tile.title}
                    setPromptCallBack={setPromptCallBack}
                />
            );
        case 'DataSelection':
            return (
                <DataManager
                    show={true}
                    onClose={handleClose}
                    icon={<DataIcon />}
                    title={tile.title}
                />
            );
        case 'TestCaseManager':
            return (
                <TileDetailUnavailable
                    show={true}
                    onClose={handleClose}
                    icon={<TestCaseIcon />}
                    title={tile.title}
                />
            );
        default:
            return (
                <TileDetailUnavailable
                    show={true}
                    onClose={handleClose}
                    icon={<DocIcon />}
                    title={tile.title}
                />
            );
    }
};

export default getTile;